import React, {useState} from 'react'

import
  PropTypes
from 'prop-types';

import * as Constants from '../../../components/common/Constants';
import chevron from '../../../images/triangle-arrow.svg'
import close from '../../../images/Close.svg'
import { PrimaryButton, SmallText, XLargeBoldText } from '../input/TextField.styles';
import {
    BlueUnderlinedBoldLink,
    DigitsContainer,
    MainContainer,
    OtpContainer,
    SplitBoxText,
    SplitOTPBoxesContainer,
    TextInputHidden
} from './OtpPopUp.styles';
import { NotificationAlerts } from '../notificationAlerts/notificationAlerts';
import {
  CloseIcon,
  FlexArticle,
  PopUpContent
} from '../popUp/PopUp.styles';
import { Snackbar } from '../snackbar/Snackbar';
import { useRef } from 'react';
import { useEffect } from 'react';

export const OtpPopUp = (props) => {

 const inputRef = useRef();
 const [isInputBoxFocused, setIsInputBoxFocused] = useState(false);
 const [ isSubmitDisabled, setIsSubmitDisabled ] = useState(true)
 const [ resetOTP, setResetOTP ] = useState(false);
 const [ otpValues, setOtpValues ] = useState(['', '', '', '', '', '']);
 const [ displayValues, setDisplayValues ] = useState(['', '', '', '', '', '']);
 const [ showOTP, setShowOTP ] = useState(false);

 const handleOnBlur = () => {
   setIsInputBoxFocused(false);
 };

 useEffect(() => {
  props.setIsPinReady(props.code.length === Constants.MAXIMUM_CODE_LENGTH);

  return () => {
    props.setIsPinReady(false);
  };
}, [props, props.code]);

useEffect(() => {
 if(props.display === 'none' || props.viewPopup === 'none') {
  props.setCode('');
  setResetOTP(true);
  setOtpValues(['', '', '', '', '', '']);
  setDisplayValues(['', '', '', '', '', '']);
  setShowOTP(false);
 }
}, [ props.display, props.viewPopup])

useEffect(() => {
  if (props.viewPopup === 'flex')
    document.querySelector('html').classList.add('hide-scroller');
  else {
    document.querySelector('html').classList.remove('hide-scroller');

  }
}, [props.viewPopup])

 const updateDisplayValues = (values, currentIndex) => {
   const newDisplayValues = [...values];

   // If showOTP is enabled, show all values
   if (showOTP) {
     setDisplayValues(values);
     return;
   }

   // Count how many digits are filled
   const filledCount = values.filter(v => v !== '').length;

   if (filledCount >= 2) {
     // Mask all filled digits except the last one being typed
     values.forEach((val, idx) => {
       if (val !== '' && idx !== currentIndex) {
         newDisplayValues[idx] = '•';
       }
     });
   }

   setDisplayValues(newDisplayValues);
 };

 const boxDigit = (_, index) => {
   return (
      <section key={index}>
        <SplitBoxText
          type='password'
          inputMode='numeric'
          value={displayValues[index] || ''}
          maxLength={1}
          max={1}
          id={index}
          onChange={(e) => {
            setResetOTP(false);
            const value = e.target.value;

            // Only allow numbers
            if (value !== '' && !/^\d$/.test(value)) {
              return;
            }

            const newOtpValues = [...otpValues];
            newOtpValues[index] = value;
            setOtpValues(newOtpValues);

            // Update display values with masking logic
            const newDisplayValues = [...newOtpValues];
            updateDisplayValues(newDisplayValues, index);

            const nextfield = document.getElementById(`${index + 1}`);

            if (nextfield && nextfield !== '' && value !== '') {
              nextfield.focus();
            }

            enableSubmit(newOtpValues);
          }}

          onKeyDown={(e) => {
            if(e.key === 'Backspace') {
              const newOtpValues = [...otpValues];

              if (e.target.value === '' && document.getElementById(`${index - 1}`)) {
                // Move to previous field if current is empty
                document.getElementById(`${index - 1}`).focus();
              } else {
                // Clear current field
                newOtpValues[index] = '';
                setOtpValues(newOtpValues);

                const newDisplayValues = [...newOtpValues];
                updateDisplayValues(newDisplayValues, index);

                enableSubmit(newOtpValues);
              }
            }
          }}

          onFocus={(e) => {
            // Show actual value when focused (only if showOTP is false)
            if (!showOTP && otpValues[index] !== '' && displayValues[index] === '•') {
              const newDisplayValues = [...displayValues];
              newDisplayValues[index] = otpValues[index];
              setDisplayValues(newDisplayValues);
            }
          }}

          onBlur={(e) => {
            // Mask the value when focus is lost (only if showOTP is false)
            if (!showOTP) {
              const filledCount = otpValues.filter(v => v !== '').length;
              if (filledCount >= 2 && otpValues[index] !== '') {
                const newDisplayValues = [...displayValues];
                newDisplayValues[index] = '•';
                setDisplayValues(newDisplayValues);
              }
            }
          }}

          onInput={(e) => {
            if(e.target.value.length > 1) {
              e.target.value = e.target.value.slice(0, 1)
            }
          }}
        ></SplitBoxText>
      </section>
   );
 };

 const boxArray = new Array(Constants.MAXIMUM_CODE_LENGTH).fill();

  const closePopUp = () => {
    props.setDisplay('none');
    props.setViewPopup('none');
  }

  const enableSubmit = (values) => {
    const allFilled = values.every(val => val !== '');

    if (allFilled) {
      setIsSubmitDisabled(false);
      props.setCode(values.join(''));
    } else {
      setIsSubmitDisabled(true);
    }
  }

  return (
    <MainContainer
      display={props.viewPopup} >
       {
        props.display &&
        <NotificationAlerts
          display={props.display}
          setDisplay={props.setDisplay}
          notificationText={props.notificationText}
        />
      }
      <OtpContainer>
        <CloseIcon>
          <span onClick={closePopUp}>
            <img width={'32px'} height={'32px'} src={close} alt='close'/>
          </span>
        </CloseIcon>

          <PopUpContent>
            <XLargeBoldText>
            Please enter your 6-digit OTP
            </XLargeBoldText>
            <FlexArticle>
              <SmallText color={'#525365'}>
                We've sent a One-Time PIN (OTP) to {props.otpSentTo[0]} and<br/>
                {props.otpSentTo[1]}<br/>
                Please enter it below to continue:
              </SmallText>
            </FlexArticle>
            <DigitsContainer>
              <SplitOTPBoxesContainer>{boxArray.map(boxDigit)}</SplitOTPBoxesContainer>
              <TextInputHidden
                value={props.code}
                max={Constants.MAXIMUM_CODE_LENGTH}
                ref={inputRef}
                onBlur={handleOnBlur}
              />
            </DigitsContainer>

            <BlueUnderlinedBoldLink onClick={() => {
              setResetOTP(true);
              setOtpValues(['', '', '', '', '', '']);
              setDisplayValues(['', '', '', '', '', '']);
              setShowOTP(false);
              props.setDisplay('none')
              props.resendOtp()
            }}>
              Resend OTP
              <img width={'12px'} height={'12px'} src={chevron} alt='chevon'/>
            </BlueUnderlinedBoldLink>
            <PrimaryButton disabled={isSubmitDisabled || resetOTP} onClick={(e) => {

              props.validateOtp(e);
            }}>
              Submit OTP
            </PrimaryButton>
          </PopUpContent>
      </OtpContainer>

      <Snackbar
        otpResendMessages={props.otpResendMessage}
        display={props.snackBarDisplay}
        setDisplay={props.setSnackBarDisplay}
      />
    </MainContainer>
  )
};

OtpPopUp.propTypes = {
  code: PropTypes.string,
  setCode: PropTypes.func,
  setIsPinReady: PropTypes.func,
  viewPopup: PropTypes.string,
  setViewPopup: PropTypes.func,
  setOtpSentto: PropTypes.func,
  otpSentTo: PropTypes.array,
  validateOtp: PropTypes.func,
  otpResendMessage: PropTypes.object,
  snackBarDisplay: PropTypes.string,
  resendOtp: PropTypes.func,
};

OtpPopUp.defaultProps = {
  code: '',
  setCode: ()=>{},
  setIsPinReady: ()=>{},
  viewPopup: '',
  setViewPopup: ()=>{},
  setOtpSentto: ()=>{},
  otpSentTo: {},
  validateOtp: ()=>{},
  otpResendMessage: {},
  snackBarDisplay: '',
  resendOtp: ()=>{},
};
